import Indicator, { IndicatorType } from '../types/Indicator'

const RelativeStrengthIndex: Indicator = {
  type: IndicatorType.OSCILLATOR,
  value: 'relativeStrengthIndex',
  label: 'Relative Strength Index',
  nickname: 'RSI',
  fields: ['relativeStrengthIndex'],
  params: {
    field: 'close',
    period: 14,
  },
}

export default RelativeStrengthIndex
